import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "../store";

const footerState = (state: RootState) => state;

const selectFooterDailyStats = createSelector(
  footerState,
  (state) => state.footer.footer,
);

export const footerSliceSelectors = { selectFooterDailyStats };
